module.exports = __webpack_public_path__ + "static/media/mbr-1920x1238.6948a8f8.jpg";